export default __webpack_public_path__ + "static/media/alarm_gentle.192dadb2.ogg";